import React, { useEffect, useRef, useState } from 'react';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faFileAudio,
    faFileVideo,
} from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import ReactPlayer from 'react-player/lazy';
import { connect } from 'react-redux';
import { VinculosAPI } from '../../../../shared/http-requests';
import { APIHelper, ToastifyHelper } from '../../../../shared/helpers';
import { ModalConstructor, SpinnerConstructor } from '../../../../shared/components';

type formatType = 'MP3'|'MP4'
interface MediaViewProps{
    // eslint-disable-next-line react/require-default-props
    codAcervo?: string
    title: string;
    // eslint-disable-next-line react/require-default-props
    uri?: string;
    format: formatType
    // eslint-disable-next-line react/require-default-props
    onClosed?: () => any
    // eslint-disable-next-line react/require-default-props
    seqParagrafo?: string;
    isRestricted: boolean,
    userRx?: { login: any};
    // eslint-disable-next-line react/require-default-props,no-restricted-globals
    open?: boolean
}

export const MediaView: React.FC<MediaViewProps> = (props) => {

    const {
        uri,
        onClosed,
        title,
        format,
        seqParagrafo,
        isRestricted,
        codAcervo,
        userRx,
        open
    } = props;


    const modalRef = useRef(null);
    const { t} = useTranslation();
    const [loading, setLoading] = useState<boolean>(true);
    const [url, setUrl] = useState<string|undefined>(uri);
    const { login } = userRx ?? {login : undefined};
    const [isOpen, setIsOpen] = useState<boolean>(false);


    useEffect(() => {
        if(open === true){
            setIsOpen(open)
            if(isRestricted) {
                (async () => {
                    setLoading(true)
                    const res = await processRestricted();
                    setIsOpen(res)
                    setLoading(false)
                })()
                return;
            }
            setLoading(false)
        }
    }, [open]);

    useEffect(() => {
        if(!isOpen && onClosed && typeof onClosed === 'function'){
            onClosed();
        }
    }, [isOpen]);


    const getRestrictedLink = async(): Promise<string|undefined> => {
        try{
            setLoading(true)
            const response = await VinculosAPI.acessarLinkAcessoRestrito(codAcervo, seqParagrafo, login)
            if(response){
                const { data } = response;
                return data;
            }
        }catch (error) {
            APIHelper.tratarErro(error)
            console.log(error)
        }
    }

    const processRestricted = async() => {
        const restrictedLink = await getRestrictedLink();
        if(!restrictedLink){
            ToastifyHelper.error("Houve um erro durante a tentativa de acesso ao vinculo.")
            return false;
        }
        setUrl(restrictedLink)
        return true;
    }
    const handleClickView = async() => {
        setIsOpen(true)

        if(isRestricted){
            setLoading(true)
            const res = await processRestricted();
            setIsOpen(res)
        }

        setLoading(false)
    }



    return (
        <>
            <Modal
                onClosed={() => {
                    if(onClosed && typeof onClosed === 'function')
                        onClosed();
                }}
                innerRef={modalRef}
                modalClassName='tema-pergamum'
                isOpen={isOpen}
                toggle={() => setIsOpen(!isOpen)}
                size='lg'
                scrollable
            >
                <ModalHeader
                    style={{padding:"1rem 1rem 10px 1rem"}}
                    className="b-solid-bottom b-branco cortxt negrito"
                    toggle={() => setIsOpen(!isOpen)}
                    /* eslint-disable-next-line react/button-has-type */
                    close={<button
                        className="close s20 branco float-right mr-1 rad5"
                        style={{ fontWeight: 'normal' }}
                        onClick={() => setIsOpen(false)}
                    >
                        <FontAwesomeIcon icon="times" className="fa-fw" />
                    </button>}
                >
                    <div className="f700 branco s20 ">
                        {title}
                    </div>
                </ModalHeader>
                <ModalBody style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    minHeight: format === 'MP4' ?  '350px' : '150px',
                    width: 'auto',
                    height: 'auto'}}>
                    {
                        // eslint-disable-next-line no-nested-ternary
                        loading ? (
                            // @ts-ignore
                            <ModalConstructor open size="xs">
                                <div className="p-4 text-center">
                                    <div>
                                        <SpinnerConstructor
                                            visible
                                            height={60}
                                            width={60}
                                            className="apergamum"
                                        />
                                        <div className="mt-3">
                                    <span className="preto70 s17 f400">
                                        {t('Aguarde')}
                                    </span>
                                        </div>
                                    </div>
                                </div>
                            </ModalConstructor>
                        ) : url ? (
                            <ReactPlayer
                                playing
                                controls
                                width="100%"
                                height={format === 'MP4' ? '100%' : '70px'}
                                url={url} />
                        ) : ''
                    }

                </ModalBody>
                <ModalFooter className="d-flex justify-content-center align-items-center position-relative">
                    <Button
                        onClick={() => setIsOpen(false)}
                        className="danger" title="Sair">
                    {t('Sair')}
                    </Button>
                </ModalFooter>
            </Modal>
            <Button className="branco hover hpreto bkverde px-2 py-1 rad5 click sverde b-none" onClick={handleClickView} title={t('AcessarMaterial')}>
                {/* @ts-ignore */}
                <FontAwesomeIcon icon={
                    format === 'MP4' ?  faFileVideo : faFileAudio
                }  className='s15'/>
            </Button>
        </>
    )
}


const mapStateToProps = (state: any) => ({
    userRx: state.auth.user,
});

export default connect(mapStateToProps)(MediaView);
